// Where an Adaptive Test card click goes, and how login pages recognise a return to the Adaptive Test tab.

export const ADAPTIVE_TEST_MARKER = "AdaptiveTest";

// Navigation state that opens the candidate's Adaptive Test tab in Profile.js.
export const ADAPTIVE_TEST_PROFILE_STATE = { type: "candidate", defaultTab: "#cat" };

// Same reading as the rest of the site (parseInt of the sessionStorage value), but only a positive id counts.
const hasId = (storage, key) => parseInt(storage.getItem(key), 10) > 0;

export function cardDestination(storage) {
  if (hasId(storage, "CandidateID")) return { kind: "profile" };
  if (hasId(storage, "MemberID")) return { kind: "memberBlocked" };
  return { kind: "login" };
}

export function isAdaptiveTestReturn(marker) {
  return marker === ADAPTIVE_TEST_MARKER;
}

// Energia's API answers with an address to send the candidate to. Only follow it if it really is
// Energia over https (energiasoi.com or one of its subdomains); anything else is refused.
export function isEnergiaUrl(url) {
  try {
    const { protocol, hostname } = new URL(url);
    return protocol === "https:" && (hostname === "energiasoi.com" || hostname.endsWith(".energiasoi.com"));
  } catch {
    return false;
  }
}
